import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button       from '@material-ui/core/Button/Button'
import Card         from '@material-ui/core/Card/Card'
import CardActions  from '@material-ui/core/CardActions'
import CardContent  from '@material-ui/core/CardContent'
import CardHeader   from '@material-ui/core/CardHeader'
import Divider      from '@material-ui/core/Divider/Divider'
import ListItem     from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography   from '@material-ui/core/Typography'
import Done         from '@material-ui/icons/Done'

import { AccountType, FinalEvaluation }                  from '../../api'
import { success }                                       from '../../theme'
import { isTeacher }                                     from '../../project-utils/permissions'
import { Communication }                                 from '../../redux/ducks'
import { FinalEvaluationDialog }                         from '../forms'
import withAccountType, { InjectedWithAccountTypeProps } from '../hocs/withAccountType'
import withToggle, { InjectedToggleProps }               from '../hocs/withToggle'

const previousInChainMap = {
  [ AccountType.Coachee ]:         'Coach',
  [ AccountType.BlcCoaching ]:     'Coachee',
  [ AccountType.CompanyCoaching ]: 'BLC',
}

interface FinalEvaluationProps extends FinalEvaluation {
  onUpdate: (values: { summary: string }) => void
  onComplete: () => void

  updateCommunication: Communication
}

type Props =
  FinalEvaluationProps
  & InjectedToggleProps
  & InjectedWithAccountTypeProps

const FinalEvaluation: React.SFC<Props> = ({
  summary,
  done,
  onComplete,
  onUpdate,
  updateCommunication,

  accountType,

  activate,
  deactivate,
  isActive,
}) => {
  const phrasing = {
    title:                   <FormattedMessage id={'project.finalEvaluation'} />,
    review:                  <FormattedMessage id={'buttonActions.review'} />,
    edit:                    <FormattedMessage id={'buttonActions.edit'} />,
    save:                    <FormattedMessage id={'buttonActions.save'} />,
    cancel:                  <FormattedMessage id={'buttonActions.cancel'} />,
    finalEvaluationComplete: <FormattedMessage id={'generic.finalEvaluationComplete'} />,
  }

  const cardHeader = <CardHeader title={phrasing.title} />

  if (
    !isTeacher(accountType)
    && (
    !summary
    || !summary.trim())
  ) {
    return (
      <Card>
        {cardHeader}
        <Divider />
        <CardContent>
          <Typography>
            <FormattedMessage
              id={'generic.waitForPreviousApproval'}
              values={{ blockedBy: previousInChainMap[ accountType as AccountType ] }}
            />
          </Typography>
        </CardContent>
      </Card>
    )
  }

  return (
    <>
      {
        (summary && !done) || (isTeacher(accountType) && !summary && !done)
          ? (
            <Card>
              {cardHeader}
              <Divider />
              <CardContent>
                <Typography>
                  <FormattedMessage id={'generic.reviewFinalEvaluation'} />
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  onClick={activate}
                  color={'primary'}
                >
                  {phrasing.review}
                </Button>
              </CardActions>
            </Card>
          )
          : (
            <Card>
              {cardHeader}
              <Divider />
              <CardContent>
                <ListItem disableGutters>
                  <Done nativeColor={success.main} />
                  <ListItemText secondary={phrasing.finalEvaluationComplete} />
                </ListItem>
              </CardContent>
              <CardActions>
                <Button onClick={activate} color={'primary'}>
                  <FormattedMessage id={'buttonActions.view'} />
                </Button>
              </CardActions>
            </Card>
          )
      }
      <FinalEvaluationDialog
        activeOnInit={isTeacher(accountType) && !summary}
        isOpen={isActive}
        done={done}
        summary={summary}
        communication={updateCommunication}
        onComplete={onComplete}
        onUpdate={onUpdate}
        onClose={deactivate}
        close={deactivate}
      />
    </>
  )
}

export default withAccountType(
  withToggle(
    FinalEvaluation
  )
)



// WEBPACK FOOTER //
// ./src/components/molecules/FinalEvaluation.tsx